module.exports = __webpack_public_path__ + "img/s-blue.861561f6.png";